<template>
  <div class="sc-thumbnail" :class="imgClass">
    <img
      :src="imgSrc"
      ref="image"
      :alt="imgAlt"
      :class="{ pointer: openLink }"
      :style="{ transform: transform }"
      @click="viewOriginal"
    />
    <i class="fas fa-external-link-alt" v-if="openLink"></i>
  </div>
</template>

<script>
import EXIF from "exif-js";

export default {
  props: {
    imgAlt: {
      type: String,
      default: ""
    },
    imgSrc: String,
    imgClass: {
      type: String,
      default: ""
    },
    openLink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orientation: 1,
      transform: "rotate(0deg)"
    };
  },
  methods: {
    viewOriginal() {
      if (this.openLink) {
        if (/^data:image/.test(this.imgSrc)) {
          const newWindow = window.open("");
          const img = new Image();
          img.src = this.imgSrc;

          setTimeout(() => {
            newWindow.document.title = "Original Image";
            newWindow.document.body.appendChild(img);
          }, 10);
        } else {
          window.open(this.imgSrc);
        }
      }
    }
  },
  watch: {
    orientation(val) {
      switch (val) {
        case 1:
          this.transform = "rotate(0deg)";
          break;
        case 2:
          this.transform = "rotate(0deg)";
          break;
        case 3:
          this.transform = "rotate(180deg)";
          break;
        case 4:
          this.transform = "rotate(180deg)";
          break;
        case 5:
          this.transform = "rotate(90deg)";
          break;
        case 6:
          this.transform = "rotate(90deg)";
          break;
        case 7:
          this.transform = "rotate(270deg)";
          break;
        case 8:
          this.transform = "rotate(270deg)";
          break;
        default:
          this.transform = "rotate(0deg)";
          break;
      }
    }
  },
  mounted() {
    const vm = this;

    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var image = new Image();
      image.onload = function() {
        EXIF.getData(xhr.response, function() {
          vm.orientation = EXIF.getTag(this, "Orientation");
        });
      };
      image.src = URL.createObjectURL(xhr.response);
    };
    xhr.open("GET", vm.imgSrc);
    xhr.responseType = "blob";
    xhr.send();
  }
};
</script>

<style lang="scss" scoped>
.sc-thumbnail {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 0 1px 0 rgba($color: $black, $alpha: 0.4);

  i {
    opacity: 0;
    position: absolute;
    background-color: $orange;
    font-size: 12px;
    color: $white;
    top: -30px;
    right: -28px;
    border-radius: 20em;
    width: 60px;
    height: 60px;
    line-height: 85px;
    padding-left: 12px;
    transition: opacity 0.25s ease;
  }
  img {
    height: 100%;
    object-fit: cover;
    position: relative;

    &:hover + i {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/helper/Thumbnail.vue